module.exports = __webpack_public_path__ + "static/img/topbg.0c129306.png";